import {api} from '../../../system/api';

export default {
    getDetailDeliveryRequest: (params) => api.get(`delivery-requests/${params.code}?agency=${params.agency}`,{...params}),
};
